import type { subscription as en } from '@/i18n/locales/en/subscription';
import type { Translation } from '@/i18n/types';

export const subscription: Translation<typeof en> = {
  title: 'Abbonamento',
  lead: 'Gestisci il tuo abbonamento — piano, pagamento e cancellazione.',
  dialogCancel: 'Annulla',
  status: {
    title: 'Stato',
    active: 'Attivo',
    inactive: 'Inattivo',
    tier: 'Piano',
    expires: 'Scade',
    autoRenews: 'Si rinnova automaticamente',
    doesNotRenew: 'Non si rinnova',
    nextCharge: 'Prossimo addebito',
    blocked: 'Al momento non puoi avviare un abbonamento web.',
  },
  plans: {
    title: 'Piani',
    monthly: 'Mensile',
    yearly: 'Annuale',
    perMonth: '{{price}} / mese',
    perYear: '{{price}} / anno',
    subscribe: 'Abbonati',
    current: 'Piano attuale',
    switchToYearly: 'Passa all’annuale',
    switchToMonthly: 'Passa al mensile',
    switchWarning:
      'Il cambio annulla l’abbonamento attuale e avvia subito quello nuovo sullo stesso mandato di pagamento. La sovrapposizione tra i due periodi non viene rimborsata — potresti essere addebitato due volte per essa.',
    switchConfirm: 'Sì, cambia piano',
    blocked:
      'Hai già un abbonamento attivo, quindi al momento non può essere avviato un altro piano.',
  },
  manage: {
    title: 'Gestisci',
    cancel: 'Annulla abbonamento',
    cancelConfirm: 'Sì, annulla',
    cancelled: 'Annullato — l’accesso rimane fino al {{date}}.',
    proRataNote:
      'Nel piano annuale, la cancellazione dopo il primo periodo di pagamento rimborsa i mesi interi non utilizzati e termina l’accesso immediatamente invece che alla fine del periodo.',
    withdraw: 'Recesso (entro 14 giorni)',
    withdrawHint: 'Disponibile per 14 giorni dopo il primo pagamento, una volta, per abbonamento.',
  },
  history: {
    title: 'Cronologia',
    empty: 'Ancora nessun acquisto.',
    date: 'Data',
    period: 'Periodo',
    channel: 'Canale',
    state: 'Stato',
    state_granted: 'Concesso',
    state_refunded: 'Rimborsato',
    state_revoked: 'Revocato',
    state_charged_back: 'Storno',
    state_rejected: 'Rifiutato',
    invoice: 'Fattura',
    withdrawLink: 'Recesso',
    manageLink: 'Gestisci nello store',
  },
  checkout: {
    title: 'Checkout',
    lead: 'Rivedi il tuo piano prima di continuare su Mollie.',
    plan: 'Piano',
    price: 'Prezzo',
    consentLabel:
      'Desidero che il servizio inizi immediatamente e comprendo che, in caso di recesso, pagherò in proporzione la parte già utilizzata.',
    start: 'Continua su Mollie',
    errorAlreadySubscribed: 'Hai già un abbonamento attivo.',
    errorProductUnavailable: 'Questo piano non è disponibile al momento.',
  },
  return: {
    title: 'Stato del pagamento',
    waiting: 'Siamo ancora in attesa della conferma del pagamento.',
    success: 'Pagamento ricevuto — il tuo abbonamento è attivo.',
    backToSubscription: 'Torna al tuo abbonamento',
  },
  withdraw: {
    title: 'Recedi dal tuo abbonamento',
    lead: 'Il recesso entro il termine di 14 giorni termina immediatamente il tuo accesso — a differenza della cancellazione, che resta valida fino alla fine del periodo già pagato.',
    refundTypeFull: 'Riceverai un rimborso completo.',
    refundTypeProRata: 'Riceverai un rimborso proporzionale per la parte non ancora utilizzata.',
    refundAmount: 'Importo del rimborso',
    deadline: 'Scadenza',
    confirm: 'Recedi e termina subito l’accesso',
    confirmed: 'Recesso effettuato — verranno rimborsati {{amount}}.',
    errorWindowExpired: 'Il termine di recesso di 14 giorni è scaduto.',
    errorAlreadyWithdrawn: 'Hai già receduto da questo abbonamento.',
  },
};
